import React, { useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import api from '../functions/api';

export default function SearchBoxOnly({ disabled, onSelectTicker }) {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  const handleInputChange = async (_, value) => {
    setInputValue(value);
    if (!value) {
      setOptions([]);
      return;
    }
    if (!token) {
      alert('Login first');
      return;
    }
    setLoading(true);
    try {
      const response = await api.get(`/search_suggestions?query=${value}`);
      setOptions(response.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Autocomplete
      freeSolo
      disableClearable
      disabled={disabled}
      options={options}
      loading={loading}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={(_, value) => {
        const ticker = value?.split(' - ')[0];
        onSelectTicker?.(ticker);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search stock"
          placeholder="Ticker or name"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
